import React, { useEffect, useReducer, useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  INDIVIDUAL,
  SCREEN_NAME_ADD_BENEFICIARY,
  TRANSFER_MONEY_URL,
  ACKNOWLEDGED,
  TOGGLE_FEATURE_OFF_FOR_REGISTRATION_FLOW,
  TOGGLE_FEATURE_ON_FOR_REGISTRATION_FLOW,
  APPROVED,
  INITIATED,
  ADD_PAYEE_URL,
  BASE_URL
} from './utils/constants';
import { useLocation } from 'react-router-dom';
import { toggleFeature } from './redux/actions/user-state/user-state-action';
import { country_code_with_new_flow } from './utils/library';
const ToggleFeatureContext = React.createContext();

const ToggleFeatureProvider = ({
  children,
  country_code,
  account_type,
  currentScreen,
  toggleFeature,
  sub_status,
  status
}) => {
  const location = useLocation();
  const [state, setState] = useReducer((s, a) => ({ ...s, ...a }), {
    toggleFeature: false,
    bgColor: 'white',
    sgMyInfo: true
  });

  useEffect(() => {
    toggleFeature(state);
  }, [state]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const ssn_addbene_display =
      country_code === 'US' &&
      status === INITIATED &&
      sub_status === 'REKYC' &&
      location.pathname.includes(ADD_PAYEE_URL);
    const approved_ack_screen =
      ['US', 'AU'].includes(country_code) &&
      status === APPROVED &&
      location.pathname.includes(`${BASE_URL}/acknowledgement/none/approved/`) &&
      account_type === INDIVIDUAL;
    const screenNameAck = location.pathname.includes('acknowledgement');
    const countries_with_new_flow_is_individual =
      country_code_with_new_flow(country_code) && account_type === INDIVIDUAL;
    const isRegistration =
      location.pathname.includes('registration') ||
      location.pathname.includes('awaiting') ||
      status !== 'APPROVED';
    const us_registration_flow =
      TOGGLE_FEATURE_OFF_FOR_REGISTRATION_FLOW.includes(country_code) && isRegistration;
    const isIndividualAndRegistered =
      country_code_with_new_flow(country_code) && account_type === INDIVIDUAL;
    const isIndividualAndOnBoardingFlowEnabled =
      TOGGLE_FEATURE_ON_FOR_REGISTRATION_FLOW.includes(country_code) && isRegistration;

    const isAddBeneScreen =
      country_code_with_new_flow(country_code) &&
      !screenNameAck &&
      (currentScreen === SCREEN_NAME_ADD_BENEFICIARY || location.pathname !== TRANSFER_MONEY_URL);

    const condition_for_bgGrey = [
      countries_with_new_flow_is_individual,
      countries_with_new_flow_is_individual && screenNameAck,
      countries_with_new_flow_is_individual && isRegistration,
      isIndividualAndRegistered && isRegistration,
      isIndividualAndOnBoardingFlowEnabled
    ];
    const condition_for_bgWhite = [
      isAddBeneScreen,
      status === ACKNOWLEDGED,
      !countries_with_new_flow_is_individual
    ];

    if (condition_for_bgGrey.some((truthy) => truthy === true)) {
      setState({ toggleFeature: true, bgColor: 'grey' });
    }
    if (condition_for_bgWhite.some((truthy) => truthy === true)) {
      setState({ bgColor: 'white' });
    }
    if (us_registration_flow && !ssn_addbene_display) {
      //remove once registrations flow is done
      setState({ toggleFeature: false, bgColor: 'white' });
    }
    if (approved_ack_screen) {
      setState({ toggleFeature: false, bgColor: 'white' });
    }
  }, [country_code, account_type, currentScreen, location.pathname, status, sub_status]);
  return <ToggleFeatureContext.Provider value={state}>{children}</ToggleFeatureContext.Provider>;
};

ToggleFeatureProvider.propTypes = {
  children: PropTypes.any,
  country_code: PropTypes.string,
  account_type: PropTypes.string,
  currentScreen: PropTypes.string,
  location: PropTypes.object,
  toggleFeature: PropTypes.any,
  status: PropTypes.any,
  sub_status: PropTypes.string
};
const mapStateToProps = ({
  rootReducer: {
    userSessionReducer: {
      user_session: { country_code, account_type }
    },
    userStatusReducer: { status, sub_status },
    userFlowReducer: { currentScreen }
  }
}) => ({
  country_code,
  account_type,
  currentScreen,
  sub_status,
  status
});
export default connect(mapStateToProps, { toggleFeature })(ToggleFeatureProvider);

export const ToggleFeatureConsumer = ({ children }) => {
  return (
    <ToggleFeatureContext.Consumer>
      {(context) => {
        const childWithFeatureProps = React.Children.map(children, (child) =>
          React.cloneElement(child, { featureState: context })
        );
        return childWithFeatureProps;
      }}
    </ToggleFeatureContext.Consumer>
  );
};

ToggleFeatureConsumer.propTypes = {
  children: PropTypes.any
};

export const useToggleFeat = () => {
  const value = useContext(ToggleFeatureContext);
  return value;
};
